import {i18n} from "../../../../Utils/i18n/i18n";
import {get, map} from 'lodash'
import {DataGridWrapper} from "../../../../Utils/DataGridWrapper/DataGridWrapper";
import {SA_getAllCompanies, SA_getAllUsersFiltered} from "../../../../Services/SA_api";
import '../AllItemsPages.scss'
import '../../SuperAdminPage.scss'
import {SAEditUserCell} from "./SAEditUserCell/SAEditUserCell";
import {GridReactContextProvider} from "../../../../Utils/DataGridWrapper/GridContext";
import {useEffect, useState} from "react";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import {SADeleteUsersTableButton} from "./SADeleteUsersTableButton/SADeleteUsersTableButton";
import {SADeleteUsersPermanentlyTableButton} from "./SADeleteUsersPermanentlyTableButton/SADeleteUsersPermanentlyTableButton";
import {RestoreUsersTableButton} from "../../../RestoreUsersTableButton/RestoreUsersTableButton";
import {CopyText} from "../../../../Utils/CopyText/CopyText";
import {IsCompanyAdminCell} from "./IsCompanyAdminCell/IsCompanyAdminCell";
import {LoginAsUserCell} from "./LoginAsUserCell/LoginAsUserCell";
import {format} from "date-fns";

const getColumns = async () => {
    return [
        {
            field: 'firstName',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.firstName"),
            minWidth: 100,
            align: 'right',
            sortable: true,
            renderCell: (params) => <div style={{width: '100%'}}>{params.value}</div>,
        },
        {
            field: 'lastName',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.lastName"),
            minWidth: 100,
            align: 'right',
            sortable: true,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        },
        {
            field: 'identifier',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.identifier"),
            minWidth: 140,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}><CopyText text={params.value}/></div>,
        },
        {
            field: 'companyName',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.companyName"),
            minWidth: 140,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}}
                                         title={get(params, 'row.company.companyName')}>{get(params, 'row.company.companyName')}</div>,
        },
        // {
        //     field: 'phone',
        //     headerName: i18n.translate("superAdmin.allUsersTable.columns.phone"),
        //     minWidth: 100,
        //     align: 'right',
        //     sortable: false,
        //     renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        // },
        // {
        //     field: 'email',
        //     headerName: i18n.translate("superAdmin.allUsersTable.columns.email"),
        //     minWidth: 140,
        //     align: 'right',
        //     sortable: false,
        //     renderCell: (params) => <div style={{width: '100%'}} title={params.value}>{params.value}</div>,
        // },
        {
            field: 'loginUrl',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.loginUrl"),
            minWidth: 140,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}><CopyText text={params.value}/></div>,
        },
        {
            field: 'isCompanyAdmin',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.isCompanyAdmin"),
            minWidth: 180,
            align: 'right',
            sortable: true,
            renderCell: (params) => <IsCompanyAdminCell user={params.row}/>
        },
        {
            field: 'isSuperAdmin',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.isSuperAdmin"),
            minWidth: 60,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>
                {get(params, 'row.roles.SuperAdmin') ? i18n.translate('superAdmin.allUsersTable.columns.yes') : i18n.translate('superAdmin.allUsersTable.columns.no')}
            </div>,
        },
        {
            field: 'deletedAt',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.isDeleted"),
            minWidth: 160,
            align: 'right',
            sortable: true,
            renderCell: (params) => {
                if (params.value) {
                    const deletedDate = format(params.value, 'dd.MM.yyyy')
                    return <div style={{width: '100%'}} title={params.value}>
                        {i18n.translate('superAdmin.allUsersTable.columns.deleted')} ({deletedDate})
                    </div>
                }
                return <div style={{width: '100%'}}>{i18n.translate('superAdmin.allUsersTable.columns.no')}</div>
            },
        },
        {
            field: 'firstWelcomeSmsDate',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.userCreatedSmsDate"),
            minWidth: 180,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}} title={params.value}>
                {params.value ? format(params.value, 'dd/MM/yyyy HH:mm') : '-'}
            </div>,
        },
        {
            field: 'loginAs',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.loginAs"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <LoginAsUserCell user={params.row}/>,
        },
        {
            field: 'edit',
            headerName: i18n.translate("superAdmin.allUsersTable.columns.edit"),
            minWidth: 200,
            align: 'right',
            sortable: false,
            renderCell: (params) => <SAEditUserCell user={params.row}/>,
        }
    ];
}

const convertData = (users) => {
    return map(users, (user) => {
        return user
    })
}
const paginationModel = {
    page: 0,
    pageSize: 100,
};

const defaultSortModel = [
    {field: 'isCompanyAdmin', sort: 'desc'},
    {field: 'deletedAt', sort: 'desc'},
    {field: 'firstName', sort: 'asc'},
    {field: 'lastName', sort: 'asc'},
]

const getFilterModel = ({companies}) => {
    return {
        filterValues: {
            companyIds: [] // Initialize for multi-select
        },
        filterData: {
            companies
        },
        showFilters: {
            search: true,
            companies: true
        }
    }
}

export const SuperAdminAllUsers = ({}) => {
    const [selectionModel, setSelectionModel] = useState([])
    const [companies, setCompanies] = useState()
    const init = async () => {
        const companies = await SA_getAllCompanies()
        const selectBoxCompanies = map(companies, (company) => {
            return {
                value: get(company, 'id'),
                text: get(company, 'companyName')
            }
        })
        setCompanies(selectBoxCompanies)
    }
    useEffect(() => {
        init()
    }, []);
    const apiToGetData = async ({paginationModel, filterModel, sortModel}) => {
        return SA_getAllUsersFiltered({paginationModel, filterModel, sortModel})
    }
    const onSelectionModelChange = ({newSelectionModel}) => {
        setSelectionModel(newSelectionModel)
    }

    const onDeleteUsersSuccess = () => {

    }

    const onRestoreUsersSuccess = () => {

    }

    const buttons = [
        {
            type: 'ComponentButton',
            component: () => <SADeleteUsersTableButton onSuccess={onDeleteUsersSuccess} />
        },
        {
            type: 'ComponentButton',
            component: () => <SADeleteUsersPermanentlyTableButton onSuccess={onDeleteUsersSuccess} />
        },
        {
            type: 'ComponentButton',
            component: () => <RestoreUsersTableButton onSuccess={onRestoreUsersSuccess} />
        }
    ]


    return <div className="allItemsWrapper SuperAdminPage">
        <GridReactContextProvider>
            {companies ? <DataGridWrapper
                isRowSelectable={(params) => {
                    // Disallow selecting SuperAdmins and Company Admins
                    const isSuperAdmin = get(params, 'row.roles.SuperAdmin');
                    const isCompanyAdmin = get(params, 'row.isCompanyAdmin');
                    return !(isSuperAdmin || isCompanyAdmin);
                }}
                filterModel={getFilterModel({companies})}
                disableColumnFilter
                getColumns={getColumns}
                paginationModel={paginationModel}
                apiToGetData={apiToGetData}
                dataConverter={convertData}
                sortModel={defaultSortModel}
                buttons={buttons}
                checkboxSelection
                onSelectionModelChange={onSelectionModelChange}
            /> : <LoadingSpinner/>}
        </GridReactContextProvider>
    </div>
}